import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { SHOP_AROUND_LIST_BODY_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { ShopAroundListBodyBlockScenarioContent } from '@front-platform/content-builder';
import {
  SHOP_AROUND_LIST_BODY_BLOCK_LOADING_VM,
  ShopAroundListBodyBlockDataSource,
  ShopAroundListBodyBlockViewModel,
} from './shop-around-list-body-block-view-model';

export function toShopAroundListBodyPreviewViewModel(
  content: ShopAroundListBodyBlockScenarioContent,
): ShopAroundListBodyBlockViewModel {
  return {
    shops: content.shops
      ? (content.shops as unknown as ShopAroundListBodyBlockViewModel['shops'])
      : undefined,
    wantedAt: content.wantedAt ? new Date(content.wantedAt) : null,
  };
}

@Injectable()
export class ShopAroundListBodyBlockPreviewDataSource implements ShopAroundListBodyBlockDataSource {
  readonly vm$: Observable<ShopAroundListBodyBlockViewModel> = previewScenarioForBloc$(
    SHOP_AROUND_LIST_BODY_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return SHOP_AROUND_LIST_BODY_BLOCK_LOADING_VM;
      }
      const content = previewScenarioData<ShopAroundListBodyBlockScenarioContent>(
        scenario,
        SHOP_AROUND_LIST_BODY_BLOCK_COMPONENT,
      );
      return content
        ? toShopAroundListBodyPreviewViewModel(content)
        : SHOP_AROUND_LIST_BODY_BLOCK_LOADING_VM;
    }),
  );
}
